// extracted by mini-css-extract-plugin
module.exports = {"spin":"Icon_spin__2S1Kr"};